import React from 'react';
import { makeStyles, fade, Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: fade(theme.palette.common.black, 0.9),
    textTransform: 'lowercase',
  },
}));

function CustomTooltip(props) {
  const classes = useStyles();

  return <Tooltip classes={classes} {...props} />;
}

export { CustomTooltip };
